import { useEffect, useState } from "react";
import { Wallet, Factory, Clock, Users, CalendarDays, CalendarRange } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { StatusBadge } from "@/components/StatusBadge";
import { PickupTodayPanel } from "@/components/PickupTodayPanel";
import { api, brl, STATUSES } from "@/lib/api";

const Kpi = ({ icon: Icon, label, value, color, testId, hint }) => (
  <div className="rounded-md border border-slate-200 bg-white p-5" data-testid={testId}>
    <div className="flex items-center justify-between">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>
      <Icon className="h-5 w-5" style={{ color }} />
    </div>
    <p className="mt-3 font-mono text-2xl font-bold text-slate-900" data-testid={`${testId}-value`}>{value}</p>
    {hint && <p className="mt-1 text-xs text-slate-500" data-testid={`${testId}-hint`}>{hint}</p>}
  </div>
);

const paidCount = (n) => `${n} ${n === 1 ? "pedido pago" : "pedidos pagos"}`;
const MONTH = new Date().toLocaleString("pt-BR", { month: "long" });

export default function AdminDashboard({ onOpenOrders }) {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {});
  }, []);

  if (!s) return <Skeleton className="h-64 rounded-md" />;
  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Painel</h1>
        <p className="text-slate-500">Visão geral das vendas e da produção.</p>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
        <Kpi icon={Wallet} label="Faturamento total (pago)" value={brl(s.revenue)} color="#0099DD" testId="kpi-revenue" />
        <Kpi icon={CalendarDays} label="Faturamento da semana" value={brl(s.revenue_week.total)} hint={`${paidCount(s.revenue_week.orders)} desde segunda-feira`} color="#0099DD" testId="kpi-revenue-week" />
        <Kpi icon={CalendarRange} label="Faturamento do mês" value={brl(s.revenue_month.total)} hint={`${paidCount(s.revenue_month.orders)} em ${MONTH}`} color="#0099DD" testId="kpi-revenue-month" />
        <Kpi icon={Factory} label="Em produção" value={s.by_status["Em produção"]} color="#E5007D" testId="kpi-production" />
        <Kpi icon={Clock} label="Aguardando pagamento" value={s.by_status["Aguardando pagamento"]} color="#EAB308" testId="kpi-awaiting" />
        <Kpi icon={Users} label="Clientes cadastrados" value={s.customers} color="#0F172A" testId="kpi-customers" />
      </div>
      <PickupTodayPanel />
      <div className="rounded-md border border-slate-200 bg-white p-6">
        <h2 className="mb-4 font-display text-lg font-bold">Pedidos por status</h2>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {STATUSES.map((st, i) => (
            <button key={st} onClick={onOpenOrders} className="space-y-2 rounded-md border border-slate-100 p-4 text-left transition-colors hover:border-sky-400" data-testid={`status-count-${i}`}>
              <StatusBadge status={st} testId={`status-count-badge-${i}`} />
              <p className="font-mono text-2xl font-bold">{s.by_status[st]}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
